import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import * as React from 'react';
import { MaxColumns } from './grid-layout.types';
import { cn } from '@utils';

const GridLayoutVariants = cva('grid', {
	variants: {
		maxColumns: {
			[MaxColumns.One]: 'grid-cols-1',
			[MaxColumns.Two]: 'grid-cols-1 sm:grid-cols-2',
			[MaxColumns.Three]: 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3',
			[MaxColumns.Four]: 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4',
			[MaxColumns.Five]: 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5',
		},
	},
	defaultVariants: {
		maxColumns: MaxColumns.Three,
	},
});

type GridLayoutProps = React.HTMLAttributes<HTMLDivElement> &
	VariantProps<typeof GridLayoutVariants> & { spacing?: number };

const GridLayout = React.forwardRef<HTMLDivElement, GridLayoutProps>(
	({ className, maxColumns, spacing = 5, ...props }, ref) => (
		<div
			data-aid="grid-layout"
			ref={ref}
			className={cn(GridLayoutVariants({ maxColumns }), `gap-${spacing}`, className)}
			{...props}
		/>
	)
);
GridLayout.displayName = 'GridLayout';

const GridLayoutSingleRow = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
	({ className, ...props }, ref) => (
		<div data-aid="grid-layout-single-row" ref={ref} className={cn('col-span-full', className)} {...props} />
	)
);
GridLayoutSingleRow.displayName = 'GridLayoutSingleRow';

export { GridLayout, GridLayoutSingleRow };
